import { ChangeDetectionStrategy, Component, DestroyRef, input, output, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MatDialog } from '@angular/material/dialog';
import { ClearDirects, DirectsState, GetDirects, UserState } from '@coin/shared/auth/feature';
import { CoinUser } from '@coin/shared/core/util-models';
import { Store } from '@ngxs/store';
import { V2ButtonComponent } from '@coin/shared/core/ui-storybook';
import { MatTabsModule } from '@angular/material/tabs';
import { TranslateModule } from '@ngx-translate/core';
import { SimplebarAngularModule } from 'simplebar-angular';
import { KeyboardMenuNavigationDirective } from '@coin/shared/core/util-directives';
import { DirectsOverviewComponent } from '../directs-overview/directs-overview.component';
import { DirectItemOverviewComponent } from './parts/direct-item-overview/direct-item-overview.component';

@Component({
  selector: 'customer-app-directs',
  templateUrl: './directs.component.html',
  styleUrls: ['./directs.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    DirectItemOverviewComponent,
    V2ButtonComponent,
    MatTabsModule,
    TranslateModule,
    SimplebarAngularModule,
    KeyboardMenuNavigationDirective
  ]
})
export class DirectsComponent {
  private dialog = inject(MatDialog);
  private store = inject(Store);

  isActive = input(false);
  // eslint-disable-next-line @angular-eslint/no-output-native
  toggle = output();
  closeMenu = output();

  user$ = this.store.select<CoinUser>(UserState.user);
  inCompanyManagerDirects = this.store.selectSignal(DirectsState.inCompanyManagerDirects);
  lineManagerDirects = this.store.selectSignal(DirectsState.lineManagerDirects);

  constructor() {
    const destroyRef = inject(DestroyRef);

    this.user$.pipe(takeUntilDestroyed(destroyRef)).subscribe(coinUser => {
      if (coinUser?.id) {
        this.store.dispatch(new GetDirects({ userId: coinUser.id }));
      } else {
        this.store.dispatch(new ClearDirects());
      }
    });
  }

  public openDirectsDialog(): void {
    this.dialog.open(DirectsOverviewComponent, {
      disableClose: true,
      width: '80vw',
      minHeight: '75%',
      maxHeight: '80vh',
      maxWidth: '1000px',
      panelClass: 'close-icon-and-transition',
      data: { lineManager: this.lineManagerDirects(), inCompanyManager: this.inCompanyManagerDirects() }
    });
  }
}
